import React from 'react';
import Stepper from '../Stepper';
import { Button, Typography } from '@thingsw/pitta-design-system';
import { useTranslation } from 'react-i18next';
import { makeStyles, Theme } from '@material-ui/core';
import ArrowBack from '@material-ui/icons/ArrowBack';
import { Skeleton } from '@material-ui/lab';
import { LightColors } from '@thingsw/pitta-modules';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'absolute',
    zIndex: 2000,
    top: 266,
    left: 200,
    width: 363,
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    alignItems: 'start',
    backgroundColor: LightColors.primary['0'],
    borderRadius: 12,
    border: `2px solid ${LightColors.primary['6']}`,
    '@media (max-height: 780px)': {
      top: 56,
    },
  },

  smallScreen: {
    top: 56,
  },
}));

interface FleetaOnboardingStepProps {
  currentStep: number;
  onNext: () => void;
  onPrev: () => void;
  onSkip: () => void;
}

const FleetaOnboardingStep5 = ({
  currentStep,
  onNext,
  onPrev,
  onSkip,
}: FleetaOnboardingStepProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [isVideoLoaded, setIsVideoLoaded] = React.useState(false);
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1300,
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 335,
          left: 180,
          zIndex: 2001,
        }}
      >
        <svg
          width='31'
          height='30'
          viewBox='0 0 31 30'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M1.55064 14.1283C0.870684 14.5105 0.870685 15.4895 1.55064 15.8717L21.6181 27.1527C22.2847 27.5275 23.1081 27.0458 23.1081 26.281L23.1081 3.71895C23.1081 2.95424 22.2847 2.47252 21.6181 2.84725L1.55064 14.1283Z'
            fill='white'
          />
          <path
            d='M22 3L1 15'
            stroke='#E9E9EA'
            strokeWidth='2'
            strokeLinecap='round'
          />
          <path
            d='M22 27L1 15'
            stroke='#E9E9EA'
            strokeWidth='2'
            strokeLinecap='round'
          />
        </svg>
      </div>
      <div className={classes.root}>
        <video
          onLoadedData={() => setIsVideoLoaded(true)}
          style={{
            width: 300,
            height: '100%',
            objectFit: 'cover',
            boxSizing: 'border-box',
            borderRadius: 12,
            display: isVideoLoaded ? 'block' : 'none',
          }}
          autoPlay
          muted
          loop
          playsInline
          webkit-playsinline
        >
          <source src='/video/onboarding5.mp4' type='video/mp4' />
        </video>
        {!isVideoLoaded && (
          <Skeleton
            variant='rect'
            style={{
              width: 300,
              height: 300,
              borderRadius: 12,
            }}
          ></Skeleton>
        )}
        <Stepper currentStep={currentStep} stepCount={6} />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
          }}
        >
          <Typography variant='H6'>{t('Geofences')}</Typography>
          <Typography variant='Body'>{t('Create geofences and2_')}</Typography>
        </div>
        <div
          style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            gap: 16,
          }}
        >
          <div>
            <Button
              variant='text'
              onClick={onPrev}
              color='gray'
              startIcon={<ArrowBack />}
            >
              {t('Back')}
            </Button>
          </div>
          <div
            style={{
              display: 'flex',
              gap: 16,
            }}
          >
            <Button onClick={onSkip} variant='text' color='gray'>
              {t('Skip tour')}
            </Button>
            <Button
              onClick={onNext}
              variant='contained'
              color='primary'
              style={{
                padding: '8px 0',
                minWidth: 58,
              }}
            >
              {t('Next')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FleetaOnboardingStep5;
